import { api } from "./api";

export type CustomFieldType =
  | "text"
  | "textarea"
  | "single_select"
  | "multi_select"
  | "date"
  | "numeric";

export interface ProjectCustomField {
  id: string;
  project_id: string;
  name: string;
  field_type: CustomFieldType;
  options: string[] | null;
  required: boolean;
  sort_order: number;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProjectCustomFieldCreate {
  name: string;
  field_type: CustomFieldType;
  options?: string[] | null;
  required?: boolean;
  sort_order?: number;
  description?: string | null;
}

export type ProjectCustomFieldUpdate = Partial<ProjectCustomFieldCreate>;

const base = (projectId: string) => `/api/projects/${projectId}/custom-fields`;

export const projectCustomFieldsApi = {
  list: (projectId: string) => api.get<ProjectCustomField[]>(base(projectId)),
  create: (projectId: string, data: ProjectCustomFieldCreate) =>
    api.post<ProjectCustomField>(base(projectId), data),
  update: (projectId: string, fieldId: string, data: ProjectCustomFieldUpdate) =>
    api.patch<ProjectCustomField>(`${base(projectId)}/${fieldId}`, data),
  delete: (projectId: string, fieldId: string) =>
    api.delete<void>(`${base(projectId)}/${fieldId}`),
};
